const bulkBookingSearchResult = (state = null, action) => {
  if (action.type === "SET_BULK_BOOKING_SEARCH_RESULT") {
    return action.payload;
  } else {
    return state;
  }
  // switch (action.type) {
  //   case "SET_BULK_BOOKING_SEARCH_RESULT": {
  //     return action.payload;
  //   }

  //   default: {
  //     return state;
  //   }
  // }
};

export default bulkBookingSearchResult;
